var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEco = function SvgEco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216-176q-45-45-70.5-104T120-402t24-124.5T222-642q35-35 86.5-60t122-39.5 161-17.5 202.5 7q8 106 5 195t-16.5 160.5-38 125T684-182q-53 53-112.5 77.5T450-80q-65 0-127-25.5T216-176m112-16q29 17 59.5 24.5T450-160q46 0 91-18.5t86-59.5q18-18 36.5-50.5t32-85 20.5-127 2-177.5q-49-2-110.5-1.5T485-670t-116 29-90 55q-45 45-62 89t-17 85q0 59 22.5 103.5T262-246q42-80 111-153.5T534-520q-72 63-125.5 142.5T328-192m0 0"
  })));
};
export default SvgEco;